import React, { useEffect, useState } from 'react'
import { useTranslation } from 'next-i18next'

import { css } from '@emotion/react'

import router from 'next/router'

import Link from '@/components/common/Link'
import { Grid } from '@/styles/grid'
import Logo from '@/components/navigation/Logo'

import LangLink from '@/components/common/LangLink'

import { mediaUp } from '@/styles/media'

import { Container, LogoWrapper, NavigationContainer } from './Navbar.styled'

interface Props {
  highlight?: boolean
}

function Navbar(props: Props) {
  const { highlight = false } = props
  const { t } = useTranslation('common')
  const [scrolled, setScrolled] = useState<boolean>(false)

  const isLegia = router.query.parking === 'legia-warszawa'

  function handleScroll() {
    setScrolled(window.pageYOffset > 10)
  }
  useEffect(() => {
    handleScroll()
    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <Container scrolled={scrolled || highlight}>
      <Grid>
        <NavigationContainer scrolled={scrolled}>
          <Link
            href={{ pathname: '/' }}
            passHref
            prefetch={false}
            css={logoWrapper}
            legacyBehavior
          >
            {isLegia ? (
              <LogoWrapper as="a" aria-label={t('a11y.pageName')}>
                <Logo />
              </LogoWrapper>
            ) : (
              <LogoWrapper as="a" aria-label={t('a11y.pageName')}>
                <Logo />
              </LogoWrapper>
            )}
          </Link>
          <nav css={linksListWrapper}>
            <ul css={linksList}>
              <li css={[linksListItem]}>
                <LangLink showOnMobileNavbar />
              </li>
            </ul>
          </nav>
        </NavigationContainer>
      </Grid>
    </Container>
  )
}

const logoWrapper = css`
  width: 30%;

  ${mediaUp('md')} {
    width: 10%;
  }

  ${mediaUp('lg')} {
    width: 15%;
  }
`

const linksListWrapper = css`
  position: relative;
  display: flex;
`

const linksList = css`
  position: relative;
  list-style: none;
  display: flex;
  align-items: center;
`

const linksListItem = css`
  margin: 9px 0;
`

export default Navbar
